export interface LendOutRequestCollection {
  id: number
  dueDate: string
  handlingType: string
  shelfType: string
  _deleteHandlingType: boolean
  revision: number
}

export function LendOutRequestCollectionToJSON(
  value: LendOutRequestCollection
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    due_date: value.dueDate !== '' ? value.dueDate : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    _delete_handling_type: value._deleteHandlingType ?? undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
